import React from 'react';
import { Button, Form, Modal } from 'semantic-ui-react';
import { TextField } from '../../common/FormFields';
import { connect } from 'react-redux';
import * as actions from '../../../redux/actions';
import { bindActionCreators } from 'redux';
import { Formik } from 'formik';
import * as yup from 'yup';

const AddFirmModal = ({ addFirm }) => {
  const [open, setOpen] = React.useState(false);

  const initialValues = { name: '' };

  const firmValidationSchema = yup.object({
    name: yup.string().required('A name is required.'),
  });

  const handleSubmit = (firm, formik) => {
    addFirm(firm);
    setOpen(false);
    formik.resetForm();
  };

  return (
    <Formik validationSchema={firmValidationSchema} initialValues={initialValues} onSubmit={handleSubmit}>
      {formik => (
        <Modal
          size="tiny"
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
          open={open}
          trigger={<Button content="Firm" labelPosition="right" positive icon="plus" />}
        >
          <Modal.Header>Create firm</Modal.Header>
          <Modal.Content>
            <Form widths="equal" onSubmit={formik.handleSubmit}>
              <Form.Group>
                <TextField
                  name="name"
                  label="Firm name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  formik={formik}
                  error={Boolean(formik.touched.name) && Boolean(formik.errors.name)}
                  errorMessage={formik.errors.name}
                />
              </Form.Group>
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button color="black" onClick={() => setOpen(false)}>
              Cancel
            </Button>
            <Button
              content="Save"
              labelPosition="left"
              onClick={formik.handleSubmit}
              icon="save"
              type="submit"
              positive
            />
          </Modal.Actions>
        </Modal>
      )}
    </Formik>
  );
};

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  addFirm: bindActionCreators(actions.firm.addFirm, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddFirmModal);
